import React from 'react';
import BodyWrapper from '../utils/BodyWrapper';
import AdminLoginContainer from '../containers/AdminLoginContainer';
function AdminLogin() {
  return (
    <>
      <BodyWrapper>
        <div className='adminlogin'>
          <AdminLoginContainer />
        </div>
      </BodyWrapper>
    </>
  );
}

export default AdminLogin;
